import { useEffect, useState } from 'react'
import { Store, UseStoreHook } from './types'

export const useStore: UseStoreHook = <Value>(
    store: Store<Value>
): [Value, (v: Value) => void] => {
    const [s, setS] = useState(store.value())

    useEffect(() => {
        const sub = store.changes().subscribe(x => {
            setS(x)
        })

        return () => {
            sub.unsubscribe()
        }
    }, [])

    return [s, store.change]
}
